/**
 * Common string delimiter constants and utility functions
 */

// Common delimiters
export const ListDelimiter = ", ";
export const TimeRangeDelimiter = "-";
export const EmptyTimeFormat = "__:__";

/**
 * Splits string into array using the delimiter
 * @param {string} value - String to split
 * @param {string} delimiter - Delimiter to use for splitting
 * @returns {Array} Array of strings
 */
export const splitByDelimiter = (value, delimiter = ListDelimiter) => {
  return value ? value.split(delimiter) : [];
};

/**
 * Join array into string using the delimiter
 * @param {Array} value - Array to join
 * @param {string} delimiter - Delimiter to use for joining
 * @returns {string} Joined string
 */
export const joinByDelimiter = (value, delimiter = ListDelimiter) => {
  return value ? value.join(delimiter) : "";
};
